import { API } from 'aws-amplify'
let getMe = token => {
  return API.get('v1', '/staging/me', {
    headers: {
      Authorization: token,
    },
  })
}
export const userService = {
  getMe,
}
